export default __webpack_public_path__ + "static/oberon-travelbase-ds-1-6944cc5462e689e1953e49e1509d0840.jpg";